import { render, staticRenderFns } from "./CustomerAssetTemplateSelectorModal.vue?vue&type=template&id=0fa84cf8"
import script from "./CustomerAssetTemplateSelectorModal.vue?vue&type=script&lang=js"
export * from "./CustomerAssetTemplateSelectorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports